import { render, staticRenderFns } from "./AutoPostingToXToggle.vue?vue&type=template&id=b8ea540a&"
import script from "./AutoPostingToXToggle.vue?vue&type=script&lang=ts&"
export * from "./AutoPostingToXToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports